<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-badge  overlap
            v-bind="attrs" v-on="on"
            :content="listaExamesLaudoPaciente.length"
            color="green"
          >
            <v-btn :disabled="listaExamesLaudoPaciente.length == 0" large depressed rounded class="rounded-card white--text" color="purple darken-2" v-bind="attrs" v-on="on">
              <v-icon>monitor_heart</v-icon>
              Laudos
            </v-btn>
          </v-badge>
        </template>
        <v-card color="primary">
            <v-toolbar dark color="purple darken-2">
                <v-btn icon dark @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Laudos</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

             <v-layout wrap justify-center :style="{ backgroundColor: 'white' }" class="mt-1">
                <v-row>
                    <!-- Coluna 1 -->
                    <v-col xs12 sm6 md4>
                        <v-list dense class="pb-0 mb-0">
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-img src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                                        aspect-ratio="1"></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title v-text="ficha.nomePaciente"></v-list-item-title>
                                      <div>
                                        <v-chip class="ma-2" color="grey darken-3" label small text-color="white">
                                            <v-icon left>mdi-label</v-icon>
                                            {{ dadosPaciente.atendimento }}
                                        </v-chip>
                                      </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>

                    <!-- Coluna 2 -->
                    <v-col xs12 sm6 md4>
                        <v-list>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        Data de Nascimento: <strong>{{ dadosPaciente.dataNascimento }}</strong>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        Idade: <strong>{{ dadosPaciente.idade }}</strong>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        Sexo: <strong>{{ dadosPaciente.sexo }}</strong>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>

                    <!-- Coluna 3 -->
                    <v-col xs12 sm12 md4>
                        <v-list>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        Cidade: <strong>{{ dadosPaciente.cidade }}</strong>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        Convênio: <strong>{{ dadosPaciente.convenio }}</strong>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        Solicitante: <strong>{{ dadosPaciente.solicitante }}</strong>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
        </v-layout>

        <v-card-text color="grey lighten-3" >
          <v-list color="primary" >
            <v-list-item-group>
              <v-card
                v-for="(consulta, index) in listaExamesLaudoPaciente"
                :key="consulta.idConsulta"
                :loading="loadUpload"
                :disabled="loadUpload"
                class="mb-4"
                elevation="1">

                <v-card-title class="d-flex justify-space-between grey lighten-4">
                  <span class="font-weight-medium">{{ consulta.nomeExame }} ({{ consulta.nomeUnidade }})</span>
                  <v-chip :color="(consulta.status!= 'A' && consulta.status != '') ? 'green' : 'primary'" class="ml-2 white--text" label>{{ (consulta.status== 'X') ? 'Liberado' : (consulta.status == '') ? 'Pendente' : (consulta.status == 'A') ? 'Pré Salvo' : (consulta.status == 'L') ? 'Liberado' : ''}}</v-chip>
                </v-card-title>

                <v-card-text class="pt-0 px-4" disabled>
                  <v-textarea
                    v-model="consulta.obsLaudoTec"
                    label="Observação"
                    outlined
                    rows="2"
                    class="mt-2"
                    :disabled="consulta.status != 'A' && consulta.status != '' && consulta.status != 'X' "
                  ></v-textarea>

                  <v-file-input
                    v-model="files[index]"
                    label="Selecione no máximo 15 arquivos"
                    chips
                    multiple
                    :error-messages="errorMessage"
                    accept="image/*,application/pdf"
                    prepend-icon="mdi-paperclip"
                    @change="preViewFiles(index)"
                    class="mt-2"
                    :disabled="consulta.status != 'A' && consulta.status != ''"
                  ></v-file-input>
                  <span class="text-caption">Arquivos selecionados: {{ listaExamesLaudoPaciente[index].files.length }}</span>

                  <v-chip-group
                    v-if="listaExamesLaudoPaciente[index].files.length > 0"
                    class="mt-3"
                    column
                  >
                    <v-chip
                      v-for="(file, index1) in listaExamesLaudoPaciente[index].files"
                      :key="file.name"
                      :close="consulta.status != 'X' && consulta.status != 'L'"
                      @click="openFile(file.url)"
                      @click:close="removeFile(index, index1)"
                    >
                      {{ file.name }}
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
                <v-card-actions class="d-flex justify-end pt-0" >
                  <v-btn  color="success" :disabled="listaExamesLaudoPaciente[index].files.length ==  0 || consulta.status == 'L' || isModified(index) == false" text @click="exibirDialogConfirmacao(index) "> Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-list-item-group>
          </v-list>
        </v-card-text>
            <!-- Dialog para pré-visualização -->
        <v-dialog v-model="dialogPreview" max-width="95%"  persistent>

            <v-card style=" height:90vh;display: flex; flex-direction: column;">
              <v-card-title>Por favor, confirme as informações.

                <v-layout wrap justify-center :style="{ backgroundColor: 'white' }" class="mt-1">
                  <v-row>
                      <!-- Coluna 1 -->
                      <v-col xs12 sm6 md4>
                          <v-list dense class="pb-0 mb-0">
                              <v-list-item>
                                  <v-list-item-avatar>
                                      <v-img src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                                          aspect-ratio="1"></v-img>
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                      <v-list-item-title v-text="ficha.nomePaciente"></v-list-item-title>
                                        <div>
                                          <v-chip class="ma-2" color="grey darken-3" label small text-color="white">
                                              <v-icon left>mdi-label</v-icon>
                                              {{ dadosPaciente.atendimento }}
                                          </v-chip>
                                        </div>
                                  </v-list-item-content>
                              </v-list-item>
                          </v-list>
                      </v-col>

                      <!-- Coluna 2 -->
                      <v-col xs12 sm6 md4>
                          <v-list>
                              <v-list-item>
                                  <v-list-item-content>
                                      <v-list-item-subtitle>
                                          Data de Nascimento: <strong>{{ dadosPaciente.dataNascimento }}</strong>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle>
                                          Idade: <strong>{{ dadosPaciente.idade }}</strong>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle>
                                          Sexo: <strong>{{ dadosPaciente.sexo }}</strong>
                                      </v-list-item-subtitle>
                                  </v-list-item-content>
                              </v-list-item>
                          </v-list>
                      </v-col>
                  </v-row>
               </v-layout>
              </v-card-title>
                <v-stepper v-model="e1">
                  <v-card style="flex-grow: 1; display: flex;  flex-direction: column; overflow: hidden;">
                    <v-stepper-header>
                      <template v-for="n in steps">
                        <v-stepper-step
                          :key="`${n}-step`"
                          :complete="e1 > n"
                          :step="n"

                        >
                          Anexo{{ n }}
                        </v-stepper-step>
                        <v-divider
                          v-if="n !== steps"
                          :key="n"
                        ></v-divider>
                      </template>
                    </v-stepper-header>
                    <v-stepper-items style="max-height: 43vh; overflow-y: auto; padding-right: 10px;">
                      <v-stepper-content
                        v-for="n in steps"
                        :key="`${n}-content`"
                        :step="n"
                      >
                          <v-card-text>
                          <template v-if="previewFileObjects[n-1] && previewFileObjects[n-1].file.type.includes('image')">
                            <v-img :src="previewFileObjects[n-1].url" max-width="100%" style="height: auto;"></v-img>
                          </template>

                          <template v-else-if="previewFileObjects[n-1] && previewFileObjects[n-1].file.type === 'application/pdf'">
                            <embed :src="previewFileObjects[n-1].url" type="application/pdf" width="100%" height="400px" />
                          </template>

                          <template v-else-if="previewFileObjects[n-1] && previewFileObjects[n-1].file.type === 'application/dcm'">
                            <p>Favor confira o arquivo DICOM em seu programa nativo</p>
                            <!-- <v-img :src="previewFileObjects[n-1].url" max-width="100%"></v-img> -->
                          </template>

                          <template v-else>
                            <v-card style="height: 90vh;">
                              <p>Tipo de arquivo não suportado para pré-visualização.</p>
                            </v-card>

                          </template>
                        </v-card-text>

                      </v-stepper-content>

                    </v-stepper-items>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn text color="red" @click="dialogPreview = false, previewFileObjects = [], files[currentIndex] = []">
                          Cancelar
                        </v-btn>
                        <v-btn
                          v-if="e1 > 1"
                          color="primary"
                          @click="e1 = e1 -1"
                        >
                          Anterior
                        </v-btn>

                        <v-btn
                          v-if="e1 < steps"
                          color="primary"
                          @click="nextStep()"
                        >
                          Próximo
                        </v-btn>
                        <v-btn
                          v-if="e1 == steps"
                          color="success"
                          @click="dialogPreview = false, confirmFiles()"
                        >
                          Confirmar
                        </v-btn>
                    </v-card-actions>
                  </v-card>

                </v-stepper>

            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogConfirmaLaudo"
            persistent
            max-width="290"
          >
            <v-card>
              <v-card-title class="text-h5">
                Tem certeza?
              </v-card-title>
              <v-card-text>Verifique se os dados estão corretos. Se estiver tudo certo e você deseja salvar o laudo, clique em Confirmar.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialogConfirmaLaudo = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialogConfirmaLaudo = false, salvarLaudo(currentIndex)"
                >
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

           <!-- Snackbar de sucesso -->
          <v-snackbar
            v-model="successSnackbar"
            bottom
            :timeout="1500"
            color="success"
          >
            Laudo salvo com sucesso!
            <template #action>
              <v-btn text @click="successSnackbar = false">OK</v-btn>
            </template>
          </v-snackbar>

          <!-- Snackbar de erro -->
          <v-snackbar
            v-model="errorSnackbar"
            bottom
            :timeout="1500"
            color="error"
          >
            Ocorreu um erro ao salvar o laudo.
            <template #action>
              <v-btn text @click="errorSnackbar = false">OK</v-btn>
            </template>
          </v-snackbar>

           <!-- <v-container>
            <v-file-input
              v-model="files"
              label="Selecione arquivos"
              chips
              multiple
              show-size
              prepend-icon="mdi-paperclip"
              @change="handleFiles"
            ></v-file-input>

            <v-chip-group
              v-if="attachmentList.length > 0"
              class="mt-4"
              column
            >
              <v-chip
                v-for="(file, index) in attachmentList"
                :key="file.name"
                close
                @click:close="removeFile(consulta.files, index)"
              >
                {{ file.name }}
              </v-chip>
            </v-chip-group>
          </v-container> -->
        </v-card>
        
    </v-dialog>

</template>

<script>

import medicoService from '../../services/medico.service'

export default {
  props: {
    ficha: Object,
    listaConsultasPaciente: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      user: '',
      dialog: false,
      files: [],
      attachmentList: [],
      listaExamesLaudoPaciente: [],
      listaExamesLaudoPacienteBkp: [],
      dadosPaciente: {},
      dialogPreview: false,
      previewFile: null,
      previewFileUrl: null,
      previewFileObjects: [],
      e1: 1,
      steps: 0,
      errorMessage: '',
      currentIndex: '',
      loadUpload: false,
      dialogConfirmaLaudo: false,
      confirmaLaudo: false,
      errorSnackbar: false,
      successSnackbar: false,
      tiposPermitidos: [
        'application/pdf',
        'application/dicom',
        'image/jpeg',
        'image/png',
        'image/jpg'
      ]
    }
  },
  mounted () { // this.listaExamesLaudoPaciente = this.listaConsultasPaciente.filter(consulta => consulta.isLaudo === 'S');
    this.user = this.$store.getters.usuario

    console.log('listaExamesLaudoPaciente: ', this.listaConsultasPaciente)

    this.listaExamesLaudoPaciente = this.listaConsultasPaciente.filter(exame => {
      // Verifica se o exame exige laudo clínico
      if (exame.exigeLaudoClinico == 1) {
        // Itera sobre os serviços escolhidos do usuário
        for (const servico of this.user.servicosEscolhidos) {
          // Verifica se o idExame está no array de exames do serviço
          if (servico.exames.includes(exame.idExame.toString())) {
            return true // Inclui o exame no resultado
          }
        }
      }
      return false // Exclui o exame do resultado
    })

    this.retornarInformacoesPacienteOs()    
    this.buscarLaudos()
  },
  created () {
    this.listaConsultasPaciente.forEach(consulta => {
      this.$set(consulta, 'obsLaudoTec', '')
      this.$set(consulta, 'status', '')
      this.$set(consulta, 'files', [])
    })
  },
  methods: {
    handleFiles (index) {
      // Adiciona apenas os arquivos novos
      console.log('entra: ', index)
      this.listaExamesLaudoPaciente[index].files.push(...this.files[index].filter(newFile =>
        !this.listaExamesLaudoPaciente[index].files.some(existingFile => existingFile.name === newFile.name)
      ))
      // console.log(this.listaExamesLaudoPaciente[index].files)
      // Limpa o file input
      this.files[index] = []
      this.previewFileObjects = []
    },
    removeFile (index, index1) {
      console.log('-----/=/: ' + index + '--- ' + index1)
      console.log('valor', this.listaExamesLaudoPaciente[index].files[index1])
      this.listaExamesLaudoPaciente[index].files.splice(index1, 1)
      // this.listaExamesLaudoPaciente[index].files = [...this.listaExamesLaudoPaciente[index].files]
      this.$forceUpdate()
    },
    preViewFiles (index) {
      console.log('files', this.files[index])
      var isErrorTypeArquivo = false
      this.files[index].forEach((file) => {
        if (!this.tiposPermitidos.some(tipo => file.type === tipo)) {
          isErrorTypeArquivo = true
        }
      })

      if ((this.listaExamesLaudoPaciente[index].files.length + this.files[index].length) > 15) {
        this.errorMessage = 'Você pode selecionar no máximo 15 arquivos.'
      } else if (isErrorTypeArquivo) {
        this.errorMessage = 'São permitidos apenas arquivos dos tipos: [.pdf, .png, .jpg, .jpeg, .dicom, .dcm]'
      } else {
        this.e1 = 1
        this.errorMessage = ''
        this.steps = this.files[index].length
        if (this.files[index] && this.files[index].length > 0) {
          // Seleciona o primeiro arquivo para visualização
          this.files[index].forEach(file => {
            const fileUrl = URL.createObjectURL(file)
            this.previewFileObjects.push({ file, url: fileUrl })
          })

          this.dialogPreview = true
          this.currentIndex = index
          console.log('FilesObjects: ', this.previewFileObjects)
        }
      }
    },
    confirmFiles () {
      this.handleFiles(this.currentIndex)
    },
    retornarInformacoesPacienteOs () {
      medicoService.medico.retornarInformacoesPacienteOs(this.ficha.idOrdemServico).then(r => {
        if (r.status == 200) {
          this.dadosPaciente = r.data
        }
      })
    },
    nextStep () {
      this.e1 = this.e1 + 1
    },
    exibirDialogConfirmacao (index) {
      this.currentIndex = index
      this.dialogConfirmaLaudo = true
    },
    async salvarLaudo (index) {
      console.log('----------- ', index)
      this.loadUpload = true
      var data = new FormData()

      data.append('idExameOs', this.listaExamesLaudoPaciente[index].idexamesos)
      data.append('idPaciente', this.ficha.idPaciente)
      data.append('idEmpresa', this.user.idEmpresa)
      data.append('idUnidadeNegocio', this.user.idUnidade)
      data.append('idPrestadorExecutante', this.user.idPrestador == null ? 95 : this.user.idPrestador)
      data.append('idUsuario', this.user.id)
      data.append('obsLaudoTec', this.listaExamesLaudoPaciente[index].obsLaudoTec)

      await this.processFiles(index)

      this.listaExamesLaudoPaciente[index].files.forEach((file, idx) => {
        data.append(`files`, file)
      })

      this.listaExamesLaudoPaciente[index].files.forEach(file => {
        console.log('Arquivo ', file)
      })

      console.log('data: ', data)

      medicoService.medico.cadastrarLaudoTec(data).then(r => {
        if (r.status == 200) {
          // this.dadosPaciente = r.data
          this.buscarLaudos()
          console.log('res: ', r.data)
          this.successSnackbar = true
        } else {
          this.errorSnackbar = true
        }
      }).finally(() => {
        this.dialogConfirmaLaudo = false
        this.confirmaLaudo = false
        this.loadUpload = false
      })
    },

    buscarLaudos () {
      if (this.listaExamesLaudoPaciente.length > 0) {
        var data = this.listaExamesLaudoPaciente.map(item => ({
          idExamesOs: item.idexamesos,
          idPaciente: this.ficha.idPaciente,
          idEmpresa: this.user.idEmpresa,
          idPrestadorExecutante: this.user.idPrestador == null ? 95 : this.user.idPrestador
        }))
        console.log('---: ', data)

        var queryString = `data=${encodeURIComponent(JSON.stringify(data))}`
        console.log('---stringg: ', queryString)
        medicoService.medico.listarLaudosTecByIdsExamesOsTec(queryString).then(r => {
          if (r.status == 200) {
          // this.dadosPaciente = r.data
            console.log('r.data: ', r.data)

            this.listaExamesLaudoPaciente.forEach(consulta => {
              r.data.forEach(item => {
              // console.log('consulta: ', consulta, 'item: ', item)
                if (consulta.idexamesos == item.idExamesOs) {
                  this.$set(consulta, 'obsLaudoTec', item.obsLaudoTec)
                  this.$set(consulta, 'status', item.status)
                  this.$set(consulta, 'files', item.files)
                }
              })
            })

            this.listaExamesLaudoPacienteBkp = structuredClone(this.listaExamesLaudoPaciente)
            console.log('------- exames laudo: ', this.listaExamesLaudoPaciente)
          }
        })
      }
    },
    isModified (index) {
      const original = JSON.stringify(this.listaExamesLaudoPaciente[index])
      const atual = JSON.stringify(this.listaExamesLaudoPacienteBkp[index])

      if (!original) return false // Se não houver estado salvo, considerar como não modificado.
      if (original.status == '') return false
      return original !== atual
    },
    async processFiles (index) {
      const filesArray = this.listaExamesLaudoPaciente[index].files

      for (let i = 0; i < filesArray.length; i++) {
        const item = filesArray[i]

        // Se o item NÃO for um File, precisa ser baixado
        if (!('lastModified' in item) && item.name && item.url) {
          try {
            const response = await fetch(item.url)

            console.log('Status da resposta:', response.status)
            console.log('Headers da resposta:', response.headers)

            if (!response.ok) {
              console.error('Erro ao baixar arquivo 111: ', item.url, response.status, response.statusText)
              return
            }

            const blob = await response.blob()
            console.log('Tamanho do blob:', blob.size) // Deve ser maior que 26 bytes
            console.log('Tipo MIME do blob:', blob.type)

            const file = new File([blob], item.name, { type: blob.type })
            console.log('Tamanho do arquivo criado:', file.size)
            console.log('Tipo MIME do arquivo criado:', file.type)

            // Substituir o objeto antigo pelo novo File
            filesArray[i] = file
          } catch (error) {
            console.error('Erro ao baixar arquivo:', item.url, error)
          }
        }
      }
    },
    openFile (url) {
      if (url) {
        window.open(url, '_blank')
      } else {
        console.error('URL inválida ou não encontrada.')
      }
    }

    // handleFiles() {
    //   // Adiciona apenas os arquivos novos
    //   this.attachmentList.push(...this.files.filter(newFile =>
    //     !this.attachmentList.some(existingFile => existingFile.name === newFile.name)
    //   ));
    //   // Limpa o file input
    //   this.files = [];
    // },
    // removeFile(index) {
    //   this.attachmentList.splice(index, 1);
    // }

  },
  watch: {
    // Limpeza do URL do objeto para evitar vazamentos de memória
    dialogPreview (val) {
      if (!val && this.previewFileUrl) {
        URL.revokeObjectURL(this.previewFileUrl)
        this.previewFileUrl = null
      }
    },
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    }
  }
}
</script>
